// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-container {
  background-color: #3ac2a8 !important;
  height: 50px;
  display: flex;
  align-items: center;
  color: #fff;
  padding: 20px;
  font-size: 17px !important;
  font-weight: 600;
}
.BC-container i {
  font-size: 21px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/layoutComponent/breadcrumb/breadcrumb.component.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AACJ;AAAI;EACI,eAAA;AAER","sourcesContent":[".BC-container{\r\n    background-color: #3ac2a8 !important;\r\n    height: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    color: #fff;\r\n    padding: 20px;\r\n    font-size: 17px !important;\r\n    font-weight: 600;\r\n    i{\r\n        font-size: 21px;\r\n    }\r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
